import { createRoot } from "react-dom/client";
import App from "./App";
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";
import { ToastContainer } from "react-toastify";

createRoot(document.getElementById("root")!).render(
  <>
    <App />
  </>
);
